import { apisettigs } from '../../settings'

function ModalConfirm(props){
    return(
        <div className="modal fade" id="ModalConfirm" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered justify-content-center">
                <div className="modal-content modalConfirmCnt">
                    <div className="modalConfirmHeader">
                        Confirmar Aprovação
                    </div>
                    <div className="mt-2">
                        <div className="modalConfirmT">
                            Comentário:
                        </div>                    
                        <div className="d-flex justify-content-center mt-2">
                            <input className="modalConfirmInpt" type="text" maxLength={60} id='nputComment'/>
                        </div>
                        <div className="mt-4 mb-4 d-flex justify-content-center ">
                            <div className='btnGrey' style={{marginLeft:'0'}} data-bs-dismiss="modal"><i className="fas fa-long-arrow-alt-left"></i></div>
                            <div className='btnGreen' id='mdlBtnApprv' clicked='no' onClick={props.approve} ><i className="fas fa-check"></i> </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


function ModalConfirmReject(props){
    return(
        <div className="modal fade" id="ModalConfirmReject" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered justify-content-center">
                <div className="modal-content modalConfirmCnt">
                    <div className="modalConfirmHeader">
                        Confirmar Rejeição
                    </div>
                    <div className="mt-2">
                        <div className="modalConfirmT">
                            Comentário:
                        </div>                    
                        <div className="d-flex justify-content-center mt-2">
                            <input className="modalConfirmInpt" type="text" maxLength={60} id='nputCommentRej' />
                        </div>
                        <div className="mt-4 mb-4 d-flex justify-content-center ">
                            <div className='btnGrey' style={{marginLeft:'0'}} data-bs-dismiss="modal"><i className="fas fa-long-arrow-alt-left"></i></div>
                            <div className='btnRed' id='mdlBtnRej' clicked='no' onClick={props.reject}><i className="fas fa-times"></i></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


function ModalWtng () {    
    return(
       <>
            <div className="modal fade" id="ModalWtng" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content modalWtngContent">
                        <img className="centerWtngImg" src= {apisettigs.serverUrl + 'static/images/loading.gif'} alt="" />
                    </div>
                </div>
            </div>
        </>
    );
}


function ModalHasUnreadMsg(){
    return(
        <div className="modal fade" id="ModalUnreadMsg" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered justify-content-center">
                <div className="modal-content modalConfirmCnt">
                    <div className="modalConfirmHeader">
                        Aviso
                    </div>
                    <div className="mt-2">
                        <div className="modalConfirmT">
                           Mensagens não lidas
                        </div>                    
                        <div className="d-flex justify-content-center modalUnreadMsgTxt">
                            Leia todas as mensagens antes de Aprovar ou Rejeitar a solicitação.
                        </div>
                        <div className="mt-4 mb-4 d-flex justify-content-center ">
                            <div className='btnGrey' style={{marginLeft:'0'}} data-bs-dismiss="modal"><i className="fas fa-long-arrow-alt-left"></i></div>                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export {
    ModalConfirm,
    ModalConfirmReject,
    ModalWtng,
    ModalHasUnreadMsg
};
